export const enum EnrollmentState {
  LOOKUP,
  SIGNIN_OPTIONS,
  VERIFICATION_OPTIONS,
  OTP,
  CREATE_PASSKEY,
  SIGNIN_PASSWORD,
  SIGNUP,
  FORGOT_PASSWORD,
  COMPLETE_PROFILE_NON_LOYALTY,
  COMPLETE_PROFILE_OTP_WELCOME,
  COMPLETE_PROFILE_WELCOME,
  COMPLETE_PROFILE_MOBILE,
  COMPLETE_PROFILE_SUBSCRIPTION,
  COMPLETE_PROFILE_OTP_SUBSCRIPTION,
  COMPLETE_PROFILE_PROFILE,
  COMPLETE_PROFILE_INTERESTS,
  COMPLETE_PROFILE_SUCCESS
}
